import { AxiosError } from 'axios';
import { useI18n } from 'contexts/i18n';
import { useMutation, useQueryClient } from 'react-query';
import { ServerStateKeysEnum } from 'reactQuery/constants';
import { dsoCartService } from 'services';
import { UpdateDsoLineItemParams } from 'types/dso/DsoCart.types';
import { DsoCartErrorResponse } from 'types';
import { displayNotification } from 'utils/notification';

export const useDsoUpdateLineItemsToCart = () => {
  const queryClient = useQueryClient();
  const i18n = useI18n();
  return useMutation(
    ServerStateKeysEnum.dsoUpdateLineitemMutation,
    ({
      childLineItemId,
      quantity,
      shipAccountNumber,
    }: UpdateDsoLineItemParams) => {
      return dsoCartService.updateLineItem(
        childLineItemId,
        quantity,
        shipAccountNumber
      );
    },
    {
      onSuccess: data => {
        queryClient.setQueriesData([ServerStateKeysEnum.dsoCart], data);
      },
      onError: (err: AxiosError<DsoCartErrorResponse>) => {
        if (err.response?.status !== 422) {
          const data = err?.response?.data;
          const errMessage =
            (data && 'error' in data ? data.error : undefined) ??
            i18n['Failed to update Cart!'];
          displayNotification(errMessage, 'danger');
        }
      },
    }
  );
};
